import { FC } from "react";
import classNames from "classnames";

import styles from "./index.less";

import { isPredefinedVersion, PricingPlanVersionEnum } from "../../types";

interface PlanTagProps {
  version: PricingPlanVersionEnum | string;
}

/**
 * 订阅计划的标签
 * @returns
 */
const PlanTag: FC<PlanTagProps> = ({ version }) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles["container-basic"]]: version === PricingPlanVersionEnum.BASIC,
        [styles["container-plus"]]: version === PricingPlanVersionEnum.PLUS,
        [styles["container-pro"]]: version === PricingPlanVersionEnum.PRO,
        [styles["container-ultra"]]: version === PricingPlanVersionEnum.ULTRA,
        [styles["container-custom"]]: !isPredefinedVersion(version),
      })}
    >
      <div className={styles.text}>
        {version === PricingPlanVersionEnum.BASIC
          ? "Basic"
          : version === PricingPlanVersionEnum.PLUS
          ? "Plus"
          : version === PricingPlanVersionEnum.PRO
          ? "Pro"
          : version === PricingPlanVersionEnum.ULTRA
          ? "Ultra"
          : version}
      </div>
    </div>
  );
};

export default PlanTag;
